import type { Order } from '@src/orders/domain/Order';
import type { PermitApplication } from '@src/orders/domain/PermitApplication';
import { CommentsField } from '@src/permitField/CommentsFields';
import { CategorySection } from '@src/permits/CategorySection';
import { useTranslation } from 'react-i18next';

export const NotesAndDocumentCategory = ({
  permitApplication,
  order,
}: {
  permitApplication: PermitApplication;
  order: Order;
}) => {
  const { t } = useTranslation();
  const fields = permitApplication.getFieldsBySection('notesAndDocuments');
  if (fields.size === 0) return null;

  return (
    <CategorySection
      title={t('orderSections.notesAndDocuments')}
      requiredFields={Array.from(fields.values()).flat()}
      permitApplication={permitApplication}
      order={order}
      subsections={[
        { label: t('comments'), fields: [CommentsField.fieldName] },
      ]}
    />
  );
};
